module.exports = __webpack_public_path__ + "static/transparent-phone-0f327370ad3835e8b3c8739746755a1f.png";